var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "_ngcontent-serverapp-c226": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9997 0C7.62594 0 0 7.62594 0 17.0003C0 26.3741 7.62594 34 16.9997 34C26.3741 34 34 26.3741 34 17.0003C34 7.62594 26.3741 0 16.9997 0ZM27.1676 9.40427L25.5313 10.9696C25.3912 11.0748 25.3195 11.2524 25.3494 11.4255V22.9314C25.3195 23.1039 25.3924 23.2815 25.5325 23.3873L27.1302 24.9514V25.294H19.0888V24.9508L20.7463 23.3469C20.907 23.1861 20.907 23.1357 20.907 22.8909V13.595L16.2996 25.2647H15.6767L10.318 13.595V21.4159C10.2713 21.7467 10.3816 22.0756 10.6145 22.3129L12.7678 24.9178V25.2603H6.66359V24.9221L8.81627 22.3129C9.04549 22.0762 9.15138 21.7411 9.09221 21.4159V12.3742C9.11712 12.1238 9.01933 11.8752 8.83309 11.7052L6.92209 9.40427V9.06168H12.865L17.4606 19.1156L21.5 9.06168H27.1676V9.40427Z",
    fill: "white",
    "_ngcontent-serverapp-c226": ""
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.5008a83fd828d8820de3c0e08f8bb71d.svg";
export { ForwardRef as ReactComponent };